import { CALL_API, getJSON } from 'redux-api-middleware';
import { normalize } from 'normalizr';
import { products } from 'schemas';
import endpoints from 'api/endpoints';
import { createQueryString } from 'utils';
import types from '../types';

export default ({ filters }) => ({
  [CALL_API]: {
    endpoint: `${endpoints.PRODUCTS_API}${createQueryString(filters)}`,
    method: 'GET',

    types: [
      types.GET_PRODUCTS_REQUEST,

      {
        type: types.GET_PRODUCTS_SUCCESS,
        payload: (action, state, res) => getJSON(res)
          .then(json => normalize(
            json,
            products.arrayOfProductSchemas,
          )),
      },

      types.GET_PRODUCTS_FAILURE,
    ],
  },
});



// WEBPACK FOOTER //
// ./src/api/products/actions/getProducts.js